import AscSvg from '@/app/icons/planets/asc.svg?react'
import ChironSvg from '@/app/icons/planets/chiron.svg?react'
import JupiterSvg from '@/app/icons/planets/jupiter.svg?react'
import LilithSvg from '@/app/icons/planets/lilith.svg?react'
import MarsSvg from '@/app/icons/planets/mars.svg?react'
import McSvg from '@/app/icons/planets/mc.svg?react'
import MercurySvg from '@/app/icons/planets/mercury.svg?react'
import MoonSvg from '@/app/icons/planets/moon.svg?react'
import NeptuneSvg from '@/app/icons/planets/neptune.svg?react'
import NnodeSvg from '@/app/icons/planets/nnode.svg?react'
import PlutoSvg from '@/app/icons/planets/pluto.svg?react'
import SaturnSvg from '@/app/icons/planets/saturn.svg?react'
import SunSvg from '@/app/icons/planets/sun.svg?react'
import UranusSvg from '@/app/icons/planets/uranus.svg?react'
import VenusSvg from '@/app/icons/planets/venus.svg?react'
import type { PLANET_RAW_SVG_MAP } from '@/app/utils/natal'
import type { FunctionalComponent } from 'preact'

export type PlanetProps = {
  size?: number
  planet: keyof typeof PLANET_RAW_SVG_MAP
  class?: string
}

export const Planet: FunctionalComponent<PlanetProps> = props => {
  switch (props.planet) {
    case 'Asc':
      return (
        <AscSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Chiron':
      return (
        <ChironSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Jupiter':
      return (
        <JupiterSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Lilith':
      return (
        <LilithSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Mars':
      return (
        <MarsSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Mc':
      return (
        <McSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Mercury':
      return (
        <MercurySvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Moon':
      return (
        <MoonSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'NNode':
      return (
        <NnodeSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Neptune':
      return (
        <NeptuneSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Pluto':
      return (
        <PlutoSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Saturn':
      return (
        <SaturnSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Sun':
      return (
        <SunSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Uranus':
      return (
        <UranusSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    case 'Venus':
      return (
        <VenusSvg
          class={props.class}
          width={props.size}
          height={props.size}
        />
      )
    default:
      return null
  }
}
